import angular from 'angular';
import passwordResetComponent from './passwordReset.component';

let passwordResetModule = angular.module('passwordReset', []).component('passwordReset', passwordResetComponent);

export default passwordResetModule;



// WEBPACK FOOTER //
// ./app/components/passwordReset/passwordReset.js